import React from 'react';
import Map from '../Map';

const MapInfo = () => {
	return (
		<div className="c-map-info o-flush-mobile u-font-sans">
			<div className="o-wrapper">
				<div className="o-row-3">
					<h2 className="c-index-title u-color-secondary">
						Get started.
						<br />
						Select your state below.
					</h2>
				</div>
				<div className="o-row-3">
					<p className="c-copy">Our licensed professionals are conveniently located in all 50 states.</p>
				</div>
				<Map />
			</div>
		</div>
	);
};

export default MapInfo;
